import MainNavigationBarClassicImpl from './main-navigation-bar-classic.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * @namespace MainNavigationBarClassic
 * @memberof Mojito.Applications.Sports
 */

/**
 * Classic design style main navigation bar offering the user to do overall application navigation.
 * <br><br>
 * It can be configured to show session time, a settings button and a help button.
 *
 * @class MainNavigationBarClassic
 * @memberof Mojito.Applications.Sports.MainNavigationBarClassic
 */

export default UIView('MainNavigationBarClassic', MainNavigationBarClassicImpl);
